import React, { useState, useEffect } from "react";
import Pagination from "../../../../../components/pagination/Pagination";
import UsersTableHeaderNew from "../users-table-header/UsersTableHeaderNew";
import { PulseLoader } from "react-spinners";
import UserRowNew from "../user-row/UserRowNew";
import AdminActionsPopupNew from "../../admin-actions-popup/AdminActionsPopupNew";
import AdminDownloadConfirmPopupNew from "../../admin-download-confirm-popup/admin-download-confirm-popup-new";
import PlaceholderEmptyScreen from "../../../../../components/PlaceholderEmptyScreen";
import AdminUserInviteModal from "../../admin-user-invite-modal/admin-user-invite-modal";
import NoUsersInvitedImage from "../../../../../assets/icons/Illustration - Missing content.svg";
import { useSelector, useDispatch } from "react-redux";
import { selectUser } from "../../../../../redux/user/user-selector";
import {
  selectSearchQueryUsers,
  selectNumUsers,
  selectIsFetchingUsers,
  selectUsers,
  selectSelectedUsers,
} from "../../../../../redux/users/users-selector";
import {
  fetchUsers,
  setSelectedUser,
} from "../../../../../redux/users/users-actions";
import {
  errorNotification,
  successNotification,
} from "../../../../../redux/notifications";
import {
  TriyoButton,
  PrimaryButton,
  SecondaryButton,
  PrimaryButtonAddUsers
} from "../../../../../components/TriyoButton";
import { useHistory } from "react-router-dom";
import "./users-table-container.styles.scss";
import { GetAllUsersComplete } from "../../../../../services/api/user-api";

const UsersTableContainerNew = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const searchQueryUsers = useSelector(selectSearchQueryUsers);
  const users = useSelector(selectUsers);
  const numUsers = useSelector(selectNumUsers);
  const loading = useSelector(selectIsFetchingUsers);
  const selectedUsers = useSelector(selectSelectedUsers);
  const privileges = user?.privileges;
  const profile = user?.profile;

  const [allUsers, setAllUsers] = useState([]);
  const [showAdminActionsPopup, setShowAdminActionsPopup] = useState(false);
  const [showDownloadsPanel, setShowDownloadsPanel] = useState(false);
  const [headerKey, setHeaderKey] = useState(false);
  const isSelfServe =
    window["APP_SETTINGS"].REACT_APP_SELFSERVE_USER === "TRUE";
  const isSuperAdmin = profile?.isSuperAdminRole;
  const canCreate = privileges.User.Add;
  const canDownload =
    (isSelfServe && canCreate && users && numUsers > 1) || !isSelfServe;
  const canArchive = selectedUsers?.length > 0;
  const showPagination = (isSelfServe && users && numUsers > 1) || !isSelfServe;
  const [firstRender, setFirstRender] = useState(true);
  const [modalData, setModalData] = useState("your company");
  const [usersCount, setUsersCount] = useState(0);
  const [prevUsersCount, setPrevUsersCount] = useState(0);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isArchived, setIsArchived] = useState(false);
  let history = useHistory();

  const refreshPage = () => {
    setHeaderKey(!headerKey);
    dispatch(
      fetchUsers({
        PageSize: 10,
        PageNumber: 1,
        SortDesc: false,
        SortBy: "name",
        Filters: [],
      })
    );
    dispatch(setSelectedUser([]));
  };

  useEffect(() => {
    const fetchData = async () => {
      refreshPage();
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      let allusersComplete = await GetAllUsersComplete();
      setAllUsers(allusersComplete);
    };
    fetchData();
  }, [users]);

  const nextPage = () => {
    const newSearchQuery = {
      ...searchQueryUsers,
      PageNumber: searchQueryUsers.PageNumber + 1,
    };
    dispatch(fetchUsers(newSearchQuery));
  };

  const prevPage = () => {
    const newSearchQuery = {
      ...searchQueryUsers,
      PageNumber: searchQueryUsers.PageNumber - 1,
    };
    searchQueryUsers.PageNumber >= 1 && dispatch(fetchUsers(newSearchQuery));
  };

  const rowChange = (numRows) => {
    dispatch(
      fetchUsers({ ...searchQueryUsers, PageSize: numRows, PageNumber: 1 })
    );
  };

  const changeData = (
    filters = searchQueryUsers.Filters,
    sortBy = searchQueryUsers.SortBy,
    sortDesc = searchQueryUsers.SortDesc
  ) => {
    dispatch(
      fetchUsers({
        ...searchQueryUsers,
        Filters: filters?.[0],
        SortBy: sortBy,
        SortDesc: sortDesc,
      })
    );
  };

  const onArchive = () => {
    if (!privileges.User.Delete === false) setShowAdminActionsPopup(true);
  };

  const renderRows = () => {
    return users?.map(({ user }) => {
      return (
        <UserRowNew
          key={user.Id}
          user={user}
          privileges={privileges}
          profile={profile}
          onArchiveSuccess={handleArchiveSuccess}
        />
      );
    });
  };

  const onClick = () => history.push("/admin/users");

  const handleArchiveSuccess = () => {
    setIsArchived(true);
  };

  const getSelectedName = (userID) => {
    if (!selectedUsers || selectedUsers.length <= 0) return "";

    let selectedRow = users.filter(({ user }) => {
      if (user.Id === userID) return true;
    });

    const userNameFull = selectedRow[0].user.Name;
    return userNameFull;
  };

  const openFromParent = () => setModalIsOpen(true);

  const handleCloseModal = (event, data) => {
    if (data) {
      if (data.type) {
        if (data.type === "success") {
          dispatch(
            successNotification({
              header: "Invitation Sent",
              message: `A new user has been invited to ${
                users ? users[0].user?.CompanyName : "your company"
              }`,
            })
          );
        } else if (data.type === "error") {
          dispatch(
            errorNotification({
              header: "Failed to invite user",
              message: "Please try again.",
            })
          );
        }
      }
    }
    setModalIsOpen(false);
  };

  useEffect(() => {
    if (users) {
      let tModalData = users[0]?.user?.CompanyName;
      if (tModalData?.length > 0) setModalData(tModalData);

      if (firstRender) {
        setUsersCount(users.length);
        setFirstRender(false);
      } else {
        setPrevUsersCount(usersCount);
        setUsersCount(users.length);
        if (prevUsersCount > usersCount && searchQueryUsers.PageNumber > 1) {
          if (prevUsersCount === searchQueryUsers.PageSize && usersCount === 1)
            prevPage();
          dispatch(setSelectedUser([]));
        }
      }
    }
  }, [users, firstRender]);

  return (
    <div className="admin-panel-table-container">
      {
        <AdminUserInviteModal
          dynData={{ organization: modalData }}
          IsModalOpened={modalIsOpen}
          onCloseModal={handleCloseModal}
          onAfterOpen={(e, data) => {}}
        />
      }
      <div className="table-control-container">
        <TriyoButton>
          {isSelfServe ? (
            <PrimaryButton
              onClick={() => openFromParent()}
              disabled={!canCreate}
              text="Invite User"
            />
          ) : (
            <PrimaryButtonAddUsers
              onClick={onClick}
              disabled={!canCreate || !allUsers.UsersAddAvailable}
              text="Create New User"
              title={allUsers?.UsersLimit ?? allUsers.UsersLimit}
              usersLimitReached={!allUsers.UsersAddAvailable}
            />
          )}
          {(isSuperAdmin || !isSelfServe) && (
            <SecondaryButton
              onClick={() => {
                setShowDownloadsPanel(true);
              }}
              disabled={!canDownload}
              text="Download Users List"
            />
          )}
          <SecondaryButton
            onClick={(e) => {
              onArchive();
              e.preventDefault();
            }}
            disabled={!canArchive}
            text="Archive"
          />
        </TriyoButton>
        {showPagination && (
          <Pagination
            key={numUsers}
            refresh={refreshPage}
            next={nextPage}
            prev={prevPage}
            rowChange={rowChange}
            numEntries={numUsers}
            query={{
              ...searchQueryUsers,
              pageNumber: searchQueryUsers.PageNumber,
              pageSize: searchQueryUsers.PageSize,
            }}
          />
        )}
      </div>
      <AdminDownloadConfirmPopupNew
        show={showDownloadsPanel}
        onHide={() => setShowDownloadsPanel(false)}
        type={"users"}
        button={"Download"}
      />
      {isSelfServe && users ? (
        !isSuperAdmin && numUsers === 1 ? (
          <PlaceholderEmptyScreen
            headerText="Invite your colleagues"
            textBeforeLink="Make the most of TRIYO by collaborating with your colleagues. Click the "
            buttonText="Invite User"
            textAfterLink=" button to get started."
            bottomImage={NoUsersInvitedImage}
            altImageText="Invite your Colleagues clicking the Invite User button"
            onClick={() => openFromParent()}
          />
        ) : (
          <div className="table-main">
            <table className="table-element">
              <UsersTableHeaderNew
                key={headerKey}
                changeData={changeData}
                refreshPage={refreshPage}
                isArchived={isArchived}
                setIsArchived={setIsArchived}
              />
              {!loading ? (
                <tbody>{renderRows()}</tbody>
              ) : (
                <div className="pulse-loader">
                  <PulseLoader></PulseLoader>
                </div>
              )}
            </table>
          </div>
        )
      ) : (
        isSelfServe &&
        !users && (
          <div className="pulse-loader">
            <PulseLoader></PulseLoader>
          </div>
        )
      )}
      {!isSelfServe && users ? (
        <div className="table-main">
          <table className="table-element">
            <UsersTableHeaderNew
              key={headerKey}
              changeData={changeData}
              refreshPage={refreshPage}
              isArchived={isArchived}
              setIsArchived={setIsArchived}
            />
            {!loading ? (
              <tbody>{renderRows()}</tbody>
            ) : (
              <div className="pulse-loader">
                <PulseLoader></PulseLoader>
              </div>
            )}
          </table>
        </div>
      ) : (
        !isSelfServe &&
        !users && (
          <div className="pulse-loader">
            <PulseLoader></PulseLoader>
          </div>
        )
      )}
      {showAdminActionsPopup && (
        <AdminActionsPopupNew
          type={"user"}
          name={selectedUsers.length === 1 && getSelectedName(selectedUsers[0])}
          selectedIDs={selectedUsers}
          showAdminActionsPopup={showAdminActionsPopup}
          setShowAdminActionsPopup={setShowAdminActionsPopup}
          onArchiveSuccess={handleArchiveSuccess}
        />
      )}
    </div>
  );
};

export default UsersTableContainerNew;
